import { createFileRoute } from '@tanstack/react-router';
import { AccountingParametersPage } from '@/features/accounting/parameters/components/AccountingParametersPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/parameters/')({
  component: AccountingParametersPage,
});
